(function(){
  function setup(container){
    container.querySelectorAll('[data-at-home-hero]').forEach(function(section){
      var button=section.querySelector('.at-home-flip');
      var image=section.querySelector('.at-home-main-image');
      if(!button||!image||button.dataset.atReady)return;
      button.dataset.atReady='true';
      var initial=button.dataset.showingFront==='true';
      button.addEventListener('click',function(){
        var front=button.dataset.showingFront!=='true';
        button.dataset.showingFront=String(front);
        image.removeAttribute('srcset');
        image.src=front?button.dataset.front:button.dataset.back;
        image.alt=button.dataset.title;
        button.textContent=(front?button.dataset.backLabel:button.dataset.frontLabel)+' ↻';
        button.setAttribute('aria-pressed',String(front!==initial));
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load',function(event){setup(event.target)});
})();
